import { render, staticRenderFns } from "./DomesticDeliverInsertedWaitForVerify.vue?vue&type=template&id=515d6f63&scoped=true"
import script from "./DomesticDeliverInsertedWaitForVerify.vue?vue&type=script&lang=js"
export * from "./DomesticDeliverInsertedWaitForVerify.vue?vue&type=script&lang=js"
import style0 from "./DomesticDeliverInsertedWaitForVerify.vue?vue&type=style&index=0&id=515d6f63&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_f8be560a05ba39e4779a4b3800f88bf1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515d6f63",
  null
  
)

export default component.exports